export const COUNT_PAGES_AROUND_ACTIVEPAGE = 1;
export const COUNT_PAGES_AROUND_ENDS = 1;
export const COUNT_ADS_PER_PAGE_ARRAY = [10, 20, 50];
